<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 account-site-popup">
  <div class="popup-overlay"></div>
  @if (_ShowDailog) {
    <kendo-window (close)="Close()" title="{{_items.length > 1 ? 'Select Account and Site' : 'Select Site'}}" class="popup-window">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 mb-3">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 body-form">
          @if (_items.length > 1) {
            <div class="col-12 row m-0 p-0 mb-4">
              <div class="col-3">
                <span class="text-style">Choose account</span>
              </div>
              <div class="col-9">
                <kendo-combobox #accountComboBox class="dropdown-list-style"
                  (selectionChange)="ChooseAccount($event)"
                  [(ngModel)]="selectedAccount"
                  [data]="_items" [textField]="'name'" [valueField]="'id'">
                </kendo-combobox>
              </div>
            </div>
          }
          <div class="col-12 row m-0 p-0">
            <div class="col-3">
              <span class="text-style">Choose site</span>
            </div>
            <div class="col-9">
              <kendo-combobox #comboboxSite class="dropdown-list-style"
                [(ngModel)]="selectedSite" [data]="_sites"
                [clearButton]="false"
                [textField]="'code'" [valueField]="'id'">
              </kendo-combobox>
            </div>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3 row m-0 px-4">
          <button (click)="Continue()" [disabled]="!selectedAccount || !selectedSite" class="btn btn-primary action-button">
            <span><img class="loginIcons" width="20" height="20" src="/assets/menu/enterprise/login-continue-icon.svg" alt="Continue" /></span>
            Continue
          </button>
        </div>
      </div>
    </kendo-window>
  }
</div>
